/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import dayjs from 'dayjs';

import { AppLeaf } from 'types/common/leaf';
import { LightState } from 'types/aspen/state';
import { OptimisticAction } from 'types/actions/optimistic';

// Helper function to handle auto-turn-on logic
const applyAutoTurnOn = (draft: AppLeaf) => {
  // Only apply to device leaves
  if (draft.type !== 'device') return;
  const currentPower = (draft.state as LightState).power?.power;
  if (currentPower === 'off' && draft.state?.power) {
    draft.state.power.updated = dayjs().unix();
    draft.state.power.power = 'on';
  }
};

export const deviceLeafReducer = (state: AppLeaf, action: OptimisticAction): AppLeaf => {
  // Type guard - only process if this is actually a device leaf
  if (state.type !== 'device') {
    return state;
  }

  switch (action.type) {
    case 'SET_BRIGHTNESS':
      return produce(state, (draft) => {
        if ('brightness' in draft.state && draft.state.brightness) {
          draft.state.brightness.updated = dayjs().unix();
          draft.state.brightness.level = action.payload;
        }
        applyAutoTurnOn(draft);
      });
    case 'SET_POWER':
      return produce(state, (draft) => {
        if (draft.state?.power) {
          draft.state.power.updated = dayjs().unix();
          draft.state.power.power = action.payload;
        }
      });
    case 'SET_COLOR':
      return produce(state, (draft) => {
        if ('color' in draft.state && draft.state.color) {
          draft.state.color.updated = dayjs().unix();
          Object.assign(draft.state.color, action.payload);
        }
        applyAutoTurnOn(draft);
      });
    default:
      return state;
  }
};
